/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: I18nFixture
// source: i18n/*/*.json

import type { LibraryType } from "@pdfking/i18n"
import type { EnumUnion } from "@pdfking/structs"
import { LibraryFromJson } from "@pdfking/i18n"

const raw: LibraryType<Readonly<{
  entities: EnumUnion<{
    ACCORDION_FOLD_10_PAGES: undefined
    ACCORDION_FOLD_12_PAGES: undefined
    ALL: undefined
    BARCODE: undefined
    BOX: undefined
    CALENDAR_BASE: undefined
    CMYK_1_PANTONE: undefined
    CMYK_2_PANTONES: undefined
    CMYK_VARNISH: undefined
    COLORS_PRINT: undefined
    COVER: undefined
    COVER_RIGHT_FLAP: undefined
    COVER_WITH_ONE_FLAP: undefined
    COVER_WITH_TWO_FLAPS: undefined
    CREATION_DATE: undefined
    CROSS_FOLD_8_PAGES: undefined
    CROSS_FOLD_C_FOLD_12_PAGES: undefined
    CUT: undefined
    C_FOLD_6_PAGES: undefined
    DIE_CUT: undefined
    DOUBLE_GATE_FOLD_8_PAGES: undefined
    ENVELOPE: undefined
    FILE: undefined
    FILLING_COMPACT: undefined
    FILLING_DISTRIBUTE: undefined
    FILLING_EVENLY: undefined
    FLIP_AS_IS: undefined
    FLIP_EFFICIENT: undefined
    FLIP_ROTATED: undefined
    FLIP_SAME_ORIENTATION: undefined
    FOLD: undefined
    FORMAT_BH: undefined
    FRONT: undefined
    FRONT_BACK: undefined
    FRONT_REAR: undefined
    GRIPPER_HEAD: undefined
    GROW_KIND_B04: undefined
    GROW_KIND_B08: undefined
    GROW_KIND_B08_ALT: undefined
    GROW_KIND_B12: undefined
    GROW_KIND_B16: undefined
    GROW_KIND_B16_ALT: undefined
    GROW_KIND_B20_ALT: undefined
    GROW_KIND_B24: undefined
    GROW_KIND_B28: undefined
    GROW_KIND_B32: undefined
    GROW_KIND_BCV: undefined
    GROW_KIND_BXA: undefined
    GROW_KIND_BXAB: undefined
    GROW_KIND_BXAF: undefined
    GROW_KIND_BXGB: undefined
    GROW_KIND_BXHT: undefined
    GROW_KIND_BXOT: undefined
    GROW_KIND_BXRSC: undefined
    GROW_KIND_BXRT: undefined
    GROW_KIND_BXSC: undefined
    GROW_KIND_BXSL: undefined
    GROW_KIND_BXTAB: undefined
    GROW_KIND_BXTE: undefined
    GROW_KIND_ENVB: undefined
    GROW_KIND_ENVC: undefined
    GROW_KIND_ENVD: undefined
    GROW_KIND_ENVP: undefined
    GROW_KIND_PACKA: undefined
    GROW_LIST_BOOK: undefined
    GROW_LIST_BOX: undefined
    GROW_LIST_COVER: undefined
    GROW_LIST_ENVELOPE: undefined
    GROW_LIST_FOLD: undefined
    GROW_LIST_FOLDER: undefined
    GROW_LIST_MISC: undefined
    HALF_FOLD_4_PAGES: undefined
    HELP: undefined
    HORIZONTAL: undefined
    HOT_FOIL: undefined
    IMPOSITION: undefined
    LAMINATION: undefined
    LOOSE_PAGE: undefined
    MARKING_AUTOBLEED: undefined
    MARKING_BN: undefined
    MARKING_BOOK: undefined
    MARKING_HELP: undefined
    MARKING_HORIZON: undefined
    MARKING_OFFSET: undefined
    MARKING_OFFSET_SAVE: undefined
    MARKING_ROTATE: undefined
    MARKING_UNIVERSE: undefined
    MARKING_UV: undefined
    MARKS: undefined
    MODE: undefined
    NOTEPAD_COVER: undefined
    NOTES: undefined
    NO_COVER: undefined
    NO_FOLD: undefined
    ONE_PANTONE: undefined
    ORIENTATION_KIND_L: undefined
    ORIENTATION_KIND_LV: undefined
    ORIENTATION_KIND_N: undefined
    ORIENTATION_KIND_NV: undefined
    ORIENTATION_KIND_P: undefined
    ORIENTATION_KIND_PV: undefined
    OVAL: undefined
    OVAL_HOLE: undefined
    OVERLAP_ALL: undefined
    OVERLAP_PAGES: { pages: unknown }
    PACKAGING: undefined
    PAGE: undefined
    PANTONE: undefined
    PARALLEL_FOLD_8_PAGES: undefined
    PREPRESS: undefined
    PRESET_BOOK: { size: unknown }
    PRESET_FILES: undefined
    PRESET_MAGAZINE: { size: unknown }
    PRESET_MAGAZINE_COVER: { size: unknown }
    PRESET_PAPERBACK: { size: unknown }
    PRESET_PLAIN: { size: unknown }
    PRINT: undefined
    PRINT_MODE_NO: undefined
    PRINT_RUN: undefined
    REAR: undefined
    RIGID_COVER: undefined
    ROUNDED_CORNERS: undefined
    ROUNDED_CORNERS_HOLE: undefined
    SCALE: undefined
    SCREEN_PRINT: undefined
    SEGNATURA: undefined
    SEMI_RIGID_COVER: undefined
    SEQUENTIAL: undefined
    SIDE_OPENING: undefined
    SYMMETRIC: undefined
    TAG_HOLE: undefined
    TEMPLATE: undefined
    TOP_OPENING: undefined
    TWO_PANTONES: undefined
    UV: undefined
    VERTICAL: undefined
    W_FOLD_8_PAGES: undefined
    Z_FOLD_6_PAGES: undefined
  }>
  form_help: EnumUnion<{ repetitions: undefined; subjects: undefined; margins: undefined }>
  form_label: EnumUnion<{
    file_id: undefined
    file_range: undefined
    file_destination: undefined
    file_scale: undefined
    orientation_kind: undefined
    size: undefined
    size_depth: undefined
    quantity: undefined
    copies: undefined
    grow_kind: undefined
    repetitions: undefined
    subjects: undefined
    security_margins: undefined
    padding: undefined
    material: undefined
    print_mode: undefined
    machine_size: undefined
    job_destination: undefined
    margins: undefined
    marking: undefined
    flip: undefined
    on_top: undefined
    filling: undefined
    bleed: undefined
    manager: undefined
  }>
}>, "en" | "fr" | "it"> = {
  entities: {
    en: () => import("../i18n/entities/en.json"),
    fr: () => import("../i18n/entities/fr.json"),
    it: () => import("../i18n/entities/it.json"),
  },
  form_help: {
    en: () => import("../i18n/form_help/en.json"),
    fr: () => import("../i18n/form_help/fr.json"),
    it: () => import("../i18n/form_help/it.json"),
  },
  form_label: {
    en: () => import("../i18n/form_label/en.json"),
    fr: () => import("../i18n/form_label/fr.json"),
    it: () => import("../i18n/form_label/it.json"),
  },
} as const

export const { entities, form_help, form_label } = LibraryFromJson(raw)
